export class UuidModel {
    public UuidId: number = 0;
    public Uuid: string = "";
}

export interface UuidModelView {
     UuidID: number
    Uuid: string
}